import {Component, OnInit, OnDestroy, Input} from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';

import {NgbAccordionConfig, NgbActiveModal, NgbModal, NgbModalRef} from '@ng-bootstrap/ng-bootstrap';
import {Phone, IPhone} from '../../shared/model/phone.model';
import {HttpErrorResponse, HttpHeaders, HttpResponse} from '@angular/common/http';
import {NgxSpinnerService} from 'ngx-spinner';
import {Observable} from 'rxjs/Rx';
import {PhoneService} from '../phone/phone.service';
import {PhoneTypeService} from '../phone-type/phone-type.service';
import {IPhoneType} from '../../shared/model/phone-type.model';
import {Customer, ICustomer} from '../../shared/model/customer.model';
import {FormBuilder} from '@angular/forms';
import {CustomerService} from './customer.service';
import {TransactionService} from '../transaction/transaction.service';
import {FieldActivityService} from '../field-activity/field-activity.service';
import {ToastrService} from 'ngx-toastr';
import {ProjectService} from '../project/project.service';
import {EmployeeService} from '../../core/employee/employee.service';
import {JhiDataUtils} from 'ng-jhipster';
import {AccountService} from '../../singelton/account.service';
import {TranslateService} from '@ngx-translate/core';
import {IProject, Project} from '../../shared/model/project.model';
import {ITransaction, Transaction} from '../../shared/model/transaction.model';
import {IActionType} from '../../shared/model/action-type.model';
import {ActionTypeService} from '../action-type/action-type.service';
import {Employee, IEmployee} from '../../shared/model/employee.model';
import {Organization} from '../../shared/model/organization.model';
import {RapidCustomerService} from './rapid-customer.service';
import {IRapidCustomer, RapidCustomer} from '../../shared/model/rapid-customer.model';
import {IConnector} from "../../shared/model/connector.model";
import {ConnectorService} from "../connector/connector.service";

// import { JhiEventManager } from 'ng-jhipster';


@Component({
  selector: 'app-customer-advanced-search-dialog',
  templateUrl: './customer-advanced-search.component.html',
  styleUrls: ['./customer-advanced-search.component.scss']
})
export class CustomerAdvancedSearchComponent implements OnInit {
  // phone: IPhone = new Phone();
  phones: IPhone[];
  phoneTypes: IPhoneType[];
  phoneTypes2: IPhoneType[];
  actionTypes: IActionType[];
  connectors: IConnector[];

  transaction: ITransaction = new Transaction();
  employees: IEmployee[];

  // rapidCustomer: IRapidCustomer = new RapidCustomer();
  phone: IPhone = new Phone();
  customer: ICustomer = new Customer();
  project: IProject = new Project();

  isSaving: boolean;

  chekNeedReminder: Boolean = false;

  dateObject: any;
  dateObject2: any;

  totalItems: any;
  queryCount: any;
  itemsPerPage: any;
  page: any;
  predicate: any;
  previousPage: any;
  reverse: any;

  showTypeOrgan = false;

  nextCustomerFormShow = false;
  @Input() phoneEdit;
  public serverValidationError = false;

  constructor(public activeModal: NgbActiveModal,
              public phoneTypeService: PhoneTypeService,
              protected customerService: CustomerService
    , private fb: FormBuilder,
              protected transactionService: TransactionService,
              protected activatedRoute: ActivatedRoute,
              protected fieldActivityService: FieldActivityService,
              protected connectorService: ConnectorService,
              private toastr: ToastrService,
              public projectService: ProjectService,
              public actionTypeService: ActionTypeService,
              private spinner: NgxSpinnerService,
              public employeeService: EmployeeService,
              protected dataUtils: JhiDataUtils,
              private modalService: NgbModal,
              protected phoneService: PhoneService,
              protected accountService: AccountService,
              protected router: Router,
              private translate: TranslateService,
              // protected rapidCustomerService: RapidCustomerService,
              config: NgbAccordionConfig

              // protected eventManager: JhiEventManager
  ) {
    this.itemsPerPage = 10;
    this.page = 1;
    this.predicate = 'itemName';
    this.reverse = 'asc';
    // this.rapidCustomer.type = 'حقیقی';

  }

  ngOnInit() {

    // this.loadAllPhoneTypes();
    // this.loadAllActionTypes();
    // this.loadAllEmployee();
    // this.loadAllConnector();
  }


  protected onSaveSuccess() {
    // this.isSaving = false;
    this.activeModal.dismiss('cancel');
    // this.toastr.success('     ثبت با موفقیت انجام شد.      ', '   کاربر گرامی!    ');

    // this.previousState();
  }

  protected onSaveError() {
    // this.isSaving = false;
  }


  goToProfile(id) {
    this.router.navigate(['/page/profile-customer-project/' + id + '/project']);
    this.clear();
  }


  selectCustomer(id) {
    // alert(' in selectCustomer ==' + id);
    this.activeModal.dismiss(id);

  }

  nextToAdd() {
    // this.loadAllPhoneTypes();

    this.nextCustomerFormShow = true;

  }


  sort2(predicate, reverse) {
    let result = ['itemName, asc'];
    if (predicate) {
      result = [predicate + ',' + reverse];
      return result;
    }
  }

  edit() {
    this.phones = [];
    this.phones.length = 0;
    this.nextCustomerFormShow = false;
  }

  search(page) {

    this.spinner.show();

    const number = (this.phone.jhiNumber ? this.phone.jhiNumber : '');
    const audience = (this.phone.audience ? this.phone.audience : '');
    const customer = (this.phone.status ? this.phone.status : '');
    const temp = 'check_isarchived';

    this.phoneService
      .search({
        page: 0,
        size: 20,
        sort: this.sort(),
        temp,
        number,
        audience, customer
      })
      .subscribe(
        (res: HttpResponse<IPhone[]>) => this.paginatePhones(res.body, res.headers),
        (res: HttpErrorResponse) => this.onError(res.message)
      );
  }

  trackId(index: number, item: IPhone) {
    return item && item.id ? item.id : index;
  }

  protected paginatePhones(data: IPhone[], headers: HttpHeaders) {

    this.phones = data;
    this.spinner.hide();

    if (this.phones && this.phones.length === 0) {
      this.nextToAdd();
    }

  }

  sort() {
    const result = ['audience, asc'];
    return result;
  }

  protected onError(errorMessage: string) {
    // this.jhiAlertService.error(errorMessage, null, null);
  }


  clear() {
    this.activeModal.dismiss('cancel');
  }

  confirmDelete(id: number) {
    this.phoneService.delete(id).subscribe(response => {

      this.activeModal.dismiss(true);
    });
  }

  save() {

  }


}
